<template>
  <div class="report--wrap">
    <div class="diagnosis-report"
         v-if="isDataReady && swasCategory"
         :key="deviceType">
      <div class="view">
        <report-info :reportType="reportType"
                     :report="report"
                     :shareData="shareData"
                     :scoreData="scoreData"
                     :summaryMap="summaryMap" />
        <div class="detail"
             :style="{ height: `calc(100vh - ${173 + headerHeight}px)` }"
             :class="{ dragging: handleMoving }"
             @mousemove="handleMove"
             @mouseup="handleUp">
          <div class="detail-list"
               :style="{ flexBasis: handlePosition + '%' }">
            <div class="check-list"
                 :class="{ reduce: !showChecklist }">
              <report-check-list :currentCategory="currentCategory"
                                 :isSummary="isSummary"
                                 :summaryMap="summaryMap"
                                 :report="report"
                                 :showChecklist="showChecklist"
                                 @onToggleChecklist="onToggleChecklist"
                                 @onCategoryClick="onCategoryClick"
                                 @onViewTypeChange="onViewTypeChange" />
            </div><div class="report"
                       :class="{ reduce: !showChecklist }">
              <report-summary v-if="isSummary"
                              :report="report"
                              :summaryMap="summaryMap"
                              @onCategoryClick="onCategoryClick" />
              <report-issue-list v-else
                                 :currentCategory="currentCategory"
                                 :categoryResultMap="categoryResultMap"
                                 :nodeDataMap="nodeDataMap"
                                 :issueData="issueData"
                                 :report="report"
                                 :currentIssue="currentIssue"
                                 @onViewTypeChange="onViewTypeChange"
                                 @onIssueClick="onIssueClick" />
            </div>
            <div class="detail-handle"
                 @mousedown="handleDown"></div>
          </div>
          <template v-if="report && report.ReportDatum && report.ReportDatum.deviceType">
            <div v-if="report.ReportDatum.deviceType < 10"
                 :style="{ flexBasis: (100 - handlePosition) + '%' }"
                 class="detail-code">
              <div class="detail-code-wrap">
                <report-capture
                  :issueData="issueData"
                  :report="report"
                  :nodeDataMap="nodeDataMap"
                  :currentIssue="currentIssue"
                  @onImageSizeChanged="onImageSizeChanged" />
                <report-code v-if="!!nodeDataMap"
                             :scrollTop="codeViewScrollTop"
                             :issueData="issueData"
                             :nodeDataMap="nodeDataMap"
                             :currentIssue="currentIssue" />
              </div>
            </div>
            <div v-else
                 :style="{ flexBasis: (100 - handlePosition) + '%' }"
                 class="detail-excel">
              <report-image :issueData="issueData"
                            :scrollTop="codeViewScrollTop"
                            :report="report"
                            :dataMap="nodeDataMap"
                            :currentIssue="currentIssue"
                            :refreshKey="handlePosition" />
            </div>
          </template>
        </div>

        <address :class="{ reduce: !showChecklist }">
          Copyright © {{ (new Date()).getFullYear() }} Seeall. All rights reserved.
          <span class="link">
            <router-link :to="{ name: 'Terms' }">Terms of Service</router-link>
          </span>
          &middot;
          <span class="link">
            <router-link :to="{ name: 'PrivacyEurope' }">Privacy Policy (Europe)</router-link>
            <router-link :to="{ name: 'PrivacyGlobal' }">(Global)</router-link>
          </span>
        </address>
      </div>
    </div>

    <template v-else>
      <div class="password-form">
        <h2>Shared Report</h2>

        <div class="password-box" v-if="isReady">
          <div v-if="!!reportTitle">
            <p class="clearfix">
              <label for="shareReportTitle">Page Name</label>
              <em id="shareReportTitle">{{ reportTitle }}</em>
            </p>
            <p class="clearfix passwordBox">
              <label for="userPW">Password</label>
              <input type="password"
                     name="userPW"
                     id="userPW"
                     v-model="model.password"
                     @keyup.enter="onViewClick" />
              <strong class="wrong"
                      v-if="errors.password">* {{ $t(errors.password) }}</strong>
            </p>
            <button type="button"
                    class="btns btn_2"
                    @click="onViewClick">{{ $t('common.confirm') }}</button>
          </div>
          <div class="no-result"
               v-else>
            <p>
              <i class="icon icon--empty"></i><br>
              {{ $t('sharedReport.deletedReport') }}
            </p>
          </div>
        </div>

        <address>
          Copyright © {{ (new Date()).getFullYear() }} Seeall. All rights reserved.<br>
          <span class="link">
            <router-link :to="{ name: 'Terms' }">Terms of Service</router-link>
          </span>
              &middot;
              <span class="link">
            <router-link :to="{ name: 'PrivacyEurope' }">Privacy Policy (Europe)</router-link>
            <router-link :to="{ name: 'PrivacyGlobal' }">(Global)</router-link>
          </span>
        </address>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'
import ReportCheckList from '@/components/valid-member/report/ReportCheckList'
import ReportInfo from '@/components/valid-member/report/ReportInfo'
import ReportSummary from '@/components/valid-member/report/ReportSummary'
import ReportIssueList from '@/components/valid-member/report/ReportIssueList'
import ReportImage from './valid-member/report/ReportImage'
import ReportCapture from '@/components/valid-member/report/ReportCapture'
import ReportCode from '@/components/valid-member/report/ReportCode'
import reportShareApi from '@/api/report-share'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'ReportShare',
  mixins: [ajaxHandlerMixin],
  components: {
    ReportCheckList,
    ReportInfo,
    ReportIssueList,
    ReportSummary,
    ReportImage,
    ReportCapture,
    ReportCode
  },
  data () {
    return {
      errors: {},
      model: {
        reportId: null,
        password: null,
        deviceType: null
      },
      token: null,
      deviceType: null,
      isReady: false,
      reportTitle: null,
      isSummary: true,
      currentCategory: null,
      currentIssue: null,
      codeViewScrollTop: 0,
      codeViewScrollLeft: 0,
      categoryResultMap: {},
      isDataReady: false,
      // report
      api: null,
      reportType: null,
      report: {},
      reportId: null,
      issueData: null,
      shareData: null,
      nodeDataMap: null,
      parentReportData: null,
      handleMoving: false,
      handlePosition: 70,
      showChecklist: false
    }
  },
  created () {
    this.token = this.$route.params.token
    this.deviceType = this.$route.params.deviceType || null
    if (this.deviceType) {
      this.deviceType = Number(this.deviceType)
      this.model.deviceType = this.deviceType
    }
    this.reportType = 'share'
    this.api = reportShareApi

    this.api.findTitleByToken(this.token).then(response => {
      if (response.data) {
        this.model.reportId = response.data.reportId
        if (response.data.title) {
          this.reportTitle = response.data.title
        }
      }

      this.isReady = true
    }).catch(this.handleAjaxError)
    if (window.innerWidth >= 1600) {
      this.showChecklist = true
    }
  },
  watch: {
    '$route.params.deviceType' (value) {
      this.deviceType = value || null
      this.model.deviceType = this.deviceType
      this.onViewClick()
    }
  },
  computed: {
    ...mapState(['headerHeight']),
    ...mapGetters(['swasCategory']),

    scoreData () {
      return this.issueData.scoreData
    },
    summaryMap () {
      const scoreMap = this.issueData.scoreMap
      const summaryMap = {}

      for (const categoryData of Object.values(this.swasCategory)) {
        const categoryId = categoryData.id
        let resultType
        let resultCssClass
        let passCount = 0
        let errorCount = 0
        let criticalPassCount = 0
        let criticalErrorCount = 0

        if (scoreMap[categoryId]) {
          _.each(scoreMap[categoryId], subScore => {
            passCount += subScore.passCount
            errorCount += subScore.errorCount
            criticalPassCount += subScore.criticalPassCount
            criticalErrorCount += subScore.criticalErrorCount
          })

          if (errorCount) {
            resultType = 'E'
            resultCssClass = 'error'
          } else if (passCount) {
            resultType = 'None'
            resultCssClass = 'none'
            // resultType = 'P'
            // resultCssClass = 'pass'
          }
        } else {
          resultType = 'None'
          resultCssClass = 'none'
        }

        summaryMap[categoryId] = {
          passCount,
          errorCount,
          criticalPassCount,
          criticalErrorCount,
          resultType,
          resultCssClass
        }
      }

      return summaryMap
    }
  },
  methods: {
    onViewClick () {
      this.errors = {}
      this.onViewTypeChange('summary')

      reportShareApi.findByToken(this.token, this.model).then(response => {
        if (!response.data) {
          throw this.getAbnormalError()
        }
        this.shareData = response.data

        this.report = this.shareData.Report
        this.issueData = this.report.jsonObject
        this.nodeDataMap = this.report.nodeDataObject
        this.report.ReportDatum.title = this.reportTitle
        this.isDataReady = true
      }).catch(this.handleAjaxError)
    },
    onCategoryClick (category) {
      const categoryId = category.id

      if (this.currentCategory && this.currentCategory.id === categoryId) {
        return
      }

      this.onIssueClick(null)

      if (this.issueData.scoreMap[categoryId]) {
        this.api.findByToken(this.token, this.model, categoryId).then(response => {
          this.categoryResultMap = response.data
          this.currentCategory = category
          this.onViewTypeChange('issue')
        }).catch(this.handleAjaxError)
      } else {
        this.categoryResultMap = {}
        this.currentCategory = category
        this.onViewTypeChange('issue')
      }
    },
    onViewTypeChange (value) {
      this.isSummary = value === 'summary'
      this.onIssueClick(null)

      if (this.isSummary) {
        this.currentCategory = null
      }
    },
    onIssueClick (issueData) {
      if (issueData) {
        this.currentIssue = _.cloneDeep(issueData)
      } else {
        this.currentIssue = null
      }

      if (this.currentIssue) {
        const el = document.getElementById(`code-id-${this.currentIssue.id}`)

        if (el) {
          this.codeViewScrollTop = el.offsetTop
        }
      }
    },
    onImageSizeChanged () {
      this.onIssueClick(null)
    },
    clearReport () {
      this.isDataReady = false
    },
    handleDown () {
      this.handleMoving = true
    },
    handleMove (event) {
      if (this.handleMoving) {
        this.handlePosition = Math.min(Math.max(((event.clientX - 10) / (window.innerWidth - 20)) * 100, 10), 90)
      }
    },
    handleUp () {
      this.handleMoving = false
    },
    onToggleChecklist () {
      this.showChecklist = !this.showChecklist
    }
  },
  destroyed () {
    this.clearReport()
  }
}
</script>

<style lang="scss" scoped>
.diagnosis-report {
  .sidebar {
    display: none;
  }

  .view {
    margin: 0 10px;

    address {
      padding: 0 0 10px 250px;
      height: 20px;
      font-size: 12px;
      font-style: normal;
      text-align: left;
      color: #767676;
      line-height: 1.7;
      transition: padding-left 0.3s ease;

      &.reduce {
        padding-left: 70px;
      }

      .link {
        margin: 0 5px;
      }
    }

    .detail {
      display: flex;
      flex-wrap:nowrap;
      height: calc(100vh - 200px);

      &.dragging * {
        user-select: none;
      }

      .detail-list {
        flex-basis: 70%;
        flex-grow: 1;
        margin: 10px;
        position: relative;
        transition: flex-basis 0.2s ease;

        .check-list {
          display: inline-block;
          height: 100%;
          width: 210px;
          margin-right: 20px;
          vertical-align: top;
          position: relative;
          transition: width 0.3s ease,
          height 0.2s ease;

          &.reduce {
            width: 33px;
            height: 33px;
          }
        }

        .report {
          display: inline-block;
          height: 100%;
          width: calc(100% - 230px);
          vertical-align: top;
          transition: width 0.3s ease;

          &.reduce {
            width: calc(100% - 53px);
          }
        }

        .detail-handle {
          position: absolute;
          top: 50%;
          right: -18.5px;
          transform: translateY(-50%);
          width: 14px;
          height: 94px;
          background: url('../assets/asset-handle.svg') no-repeat;
          cursor: ew-resize;
        }
      }

      .detail-code,
      .detail-excel {
        flex-basis: 30%;
        flex-grow: 1;
        overflow: hidden;
        margin: 10px;
        transition: flex-basis 0.2s ease;
      }

      .detail-code {
        border-radius: 10px;
        box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);

        .detail-code-wrap {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
      }
    }
  }
}

.password-form {
  width: 1194px;
  padding: 0 15px;
  margin: 0 auto;

  address {
    padding: 30px 15px 40px;
    font-size: 12px;
    font-style: normal;
    text-align: center;
    color: #767676;
    line-height: 1.7;

    .link {
      margin: 0 5px;
    }
  }

  h2 {
    font-size: 30px;
    font-weight: 600;
    color: #151515;
    padding-top: 55px;
    display: inline-block;
    margin: 0 10px;
  }

  .password-box {
    margin-top: 15px;
    border-radius: 10px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    padding: 30px 0 50px;
    text-align: center;

    p {
      margin: 30px 0;

      label {
        font-size: 13px;
        font-weight: 500;
        line-height: 1;
        color: #767676;
        width: 120px;
        display: inline-block;
        vertical-align: middle;
        text-align: right;
        padding-right: 19px;
      }

      em {
        display: inline-block;
        vertical-align: middle;
        width: 330px;
        height: 38px;
        line-height: 38px;
        text-align: left;
        padding: 0 12px;
        box-sizing: border-box;
      }

      .wrong {
        display: block;
        margin-top: 5px;
        margin-left: 15px;
        font-size: 12px;
        font-weight: normal;
        color: #ec0047;
        white-space: nowrap;
      }

      input[type=text],
      input[type=password] {
        padding: 12px;
        border-radius: 6px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        width: 330px;
        height: 38px;
        line-height: 38px;
        transition: border-color 0.2s ease;
        vertical-align: middle;
        box-sizing: border-box;

        &:focus {
          border-color: #289eef;
        }

        &.error {
          border-color: #ec0047;
        }
      }
    }
  }

  .no-result {
    min-height: 545px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      text-align: center;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #767676;
      padding-bottom: 70px;

      i {
        margin-bottom: 10px;
      }
    }
  }
}

.toast-wide { min-width: 350px; }
</style>



// WEBPACK FOOTER //
// src/components/ShareReport.vue